import { AppConfig } from 'src/app/configs/app-config';
import { CivilStatus } from '../models/enum/civil-status.enum';
import { Pac } from '../models/worker/wresponse-data';
import { ParentescoMapeadoEnum, TipoParentescoEnum } from '../enums/tipo-parentesco.enum';

class ReglasACM {
  public constructor(
    private edadMin: number,
    private edadMax: number,
    private estadosCivil?: string[]) {
      this.edadMin = edadMin;
      this.edadMax = edadMax;
      this.estadosCivil = estadosCivil || [];
  }

  public esEdadPermitida(edad: number): boolean {
    return (edad >= this.edadMin && edad <= this.edadMax);
  }

  public esEstadoCivilValido(estadoCivilAfiliado: string) {
    if (this.estadosCivil.length == 0)
      return true;

    return this.estadosCivil.includes(estadoCivilAfiliado);
  }
}

export class ACMValidator {
  private static horaMin = 96;
  private static categoriasPermitidas = ["A", "B"];
  private static reglasPadres = new ReglasACM(60, 120);
  private static reglasHijosHermanos =  new ReglasACM(0, 18);
  private static reglasHijastro = new ReglasACM(0, 18, [CivilStatus.FREE_UNION.codigo, CivilStatus.MARRIED.codigo]);
  private static reglasACM = {
      Hijo: ACMValidator.reglasHijosHermanos,
      Hermano: ACMValidator.reglasHijosHermanos,
      Hijastro: ACMValidator.reglasHijastro,
      Padre: ACMValidator.reglasPadres,
      Madre: ACMValidator.reglasPadres
  }

  public static hasRequest(numberDoc: string, data: Array<any>) {
    return data.some(r => r == numberDoc);
  }

  public static esAfiliacionVigente(estadoAfiliacion: string): Boolean {
    return (estadoAfiliacion == 'VIGEN');
  }

  public static esCategoriaPermitida(categoriaAfiliado: string): Boolean {
    return this.categoriasPermitidas.includes(categoriaAfiliado);
  }

  public static esAcreditacionCuotaMonetariaValida(edadBeneficiario: number, parentescoBeneficiario: string, estadoCivilAfiliado: string, horasTrabajadas: number,): Boolean {
    const reglasParentesco: ReglasACM = this.reglasACM[parentescoBeneficiario];

    if (!reglasParentesco) {
      return false;
    }

    return (reglasParentesco.esEstadoCivilValido(estadoCivilAfiliado) &&
            reglasParentesco.esEdadPermitida(edadBeneficiario) &&
            this.esHorasPermitida(horasTrabajadas));
  }

  public static esHorasPermitida(horas: number): boolean {
    return (horas*30 >= this.horaMin);
  }

  public static obtenerCategoriaPorSalario(salario: number): boolean {
    let SalarioDefault: number = AppConfig.salarioMinimo();
    let esSalarioParaCuotaMonetaria = (salario <= SalarioDefault*4);

    return esSalarioParaCuotaMonetaria;
  }

  public static esSalarioConConyugePermitido(salarioConyuge: number, SalarioEmpleado: number): boolean {
    let salario = salarioConyuge + SalarioEmpleado;
    return this.obtenerCategoriaPorSalario(salario);
  }

  public static esAcreditacionCuotaMonetariaYCategoriaValida(
                      categoriaTitular: Boolean,
                      edadBeneficiario: any,
                       parentescoBeneficiario: any,
                      estadoCivilAfiliado: any,
                      horasLaboradasTitular: any): Boolean {
  return (categoriaTitular &&
          ACMValidator.esAcreditacionCuotaMonetariaValida(
            edadBeneficiario,
            parentescoBeneficiario,
            estadoCivilAfiliado,
            horasLaboradasTitular));
  }

  public static calcularSalarioConyuge(pac: Pac): number {
    const valorMapeado: string = ParentescoMapeadoEnum.CONYUGE;
    if (pac.relacion.codigo === valorMapeado && pac.cuotaMonetaria && pac.cuotaMonetaria.salario !== null) {
      return Number(pac.cuotaMonetaria.salario);
    }
    return 0;
  }  
}
